import { ListReviews } from "@tecnobit-srl/content-types-list-reviews/lazy";
import { jsx } from "react/jsx-runtime";
//#region \0rolldown/runtime.js
var __defProp = Object.defineProperty;
var __exportAll = (all, no_symbols) => {
	let target = {};
	for (var name in all) __defProp(target, name, {
		get: all[name],
		enumerable: true
	});
	if (!no_symbols) __defProp(target, Symbol.toStringTag, { value: "Module" });
	return target;
};
//#endregion
//#region src/consultant-reviews.tsx
var consultant_reviews_exports = /* @__PURE__ */ __exportAll({ ConsultantReviews: () => ConsultantReviews });
/**
* The generic reviews list, scoped to one consultant.
*
* The backend pins the consultant in the contextual endpoint path. Rendering is
* delegated to the reviews package rather than duplicated.
*/
function ConsultantReviews({ showAverage = false, showAllReviews = false, allReviewsHref, allReviewsText, perPage = 12, infiniteScroll = false, fetchUrl = "", average, total = 0, items, page = 1, totalItems }) {
	if (!fetchUrl && items === void 0) return null;
	return /* @__PURE__ */ jsx(ListReviews, {
		showAverage,
		showAllReviews,
		allReviewsHref,
		allReviewsText,
		perPage,
		infiniteScroll,
		fetchUrl,
		items,
		page,
		totalItems: totalItems ?? total,
		initialAverage: average ?? 0
	});
}
//#endregion
export { consultant_reviews_exports as n, ConsultantReviews as t };
